




































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { VehicleReviveCenter, VehicleReviveCenterViewModel } from '@/models/inventory/vehiclerevivecenter';
import { Base } from '@/components/common/base';
import {vehicleReviveCenterService,storeService} from '@/shared';

@Component({
    props: ['isDialog', 'addressDialog', 'methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class VehicleReviveCenterAddPage extends Base {
    get trigger(): boolean {
        return this.$props.dialog;
    }
    set trigger(val) {
        this.$emit('closedialog', val);
    }
    public isDialog: boolean;
    public addressDialog: any;
    public vehicleFields: Array<VFields<any>> = [];
    public valid: boolean = true;
    public vehicleReviveCenter: VehicleReviveCenterViewModel = {
        name: '', stores: [], type: 'New',
    };
    public vehicleReviveTypes: string[] = ['New', 'Used'];
    public selectedIds: string[] = [];
    public stores: any[] = [];
    public isAddUpdateButton = true;
    public disableSubmitButton: boolean = false;
    public isStoresLoading: boolean = false;
    public isVehicleReviveCenterLoading: boolean = false;

    public created(): void {
        this.setFields();
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToList') {
            this.$router.push({ name: 'admin.vehiclerevivecenter' });
        } else if (methodName === 'submit') {
            if (!this.vehicleReviveCenter.name || !this.vehicleReviveCenter.type || !(this.selectedIds.length > 0) || !this.isAddUpdateButton || this.disableSubmitButton) {
                this.showAlert(false, this.$t('vehicleReviveCenter.alertNameTypeStoreRequired'));
                this.resetMethodName(methodName);
                return;
            }
            this.submitVehicleReviveCenter();
        }

        this.resetMethodName(methodName);
    }

    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$parent.$t('vehicleReviveCenter.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('vehicleReviveCenter.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vehicleReviveCenter');
        
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.setFields();
        if (this.$route.params.id) {
            this.getVehicleReviveCenterById();
        }
        this.getStores();
    }
    public async getStores(): Promise<void> {
        try {
            this.isStoresLoading = true;
            const stores = await storeService.getStoresList();
            this.stores = stores.results;
        } finally {
            this.isStoresLoading = false;
        }
    }

    public async getVehicleReviveCenterById(): Promise<void> {
        try {
            this.isVehicleReviveCenterLoading = true;
            const resp = await vehicleReviveCenterService
                .getVehicleReviveCenterById(Number(this.$route.params.id));
            this.vehicleReviveCenter = resp;
            this.selectedIds = this.vehicleReviveCenter.stores.map((x) => x.id.toString());
        } finally {
            this.isVehicleReviveCenterLoading = false;
        }
    }


    public async submitVehicleReviveCenter(): Promise<void> {
        if(this.validateForm()){
            if(!this.vehicleReviveCenter.name && this.vehicleReviveCenter.stores){
                return;
            }
            this.isAddUpdateButton = false;

            const data = this.vehicleReviveCenter;
            const selectedStores = this.stores.filter((x) => this.selectedIds.indexOf(x.id.toString()) > - 1);
            this.vehicleReviveCenter.stores = selectedStores;

            if (this.$route.params.id) {
                try {
                    this.disableSubmitButton = true;
                    this.$emit('update:progress', this.disableSubmitButton);
                    const res = await vehicleReviveCenterService.
                        updateVehicleReviveCenter(this.vehicleReviveCenter);
                    this.showAlert(true, this.$t('vehicleReviveCenter.alertUpdateVehicleReviveCenter'));
                    this.backToList();
                    this.isAddUpdateButton = true;
                } finally {
                    this.isAddUpdateButton = true;
                    this.disableSubmitButton = false;
                    this.$emit('update:progress', this.disableSubmitButton);
                }
            } else {
                try {
                    this.disableSubmitButton = true;
                    this.$emit('update:progress', this.disableSubmitButton);
                    await vehicleReviveCenterService.addVehicleReviveCenter(this.vehicleReviveCenter);
                    this.showAlert(true, this.$t('vehicleReviveCenter.alertSaveVehicleReviveCenter'));
                    this.backToList();
                    this.isAddUpdateButton = true;
                } finally {
                    this.isAddUpdateButton = true;
                    this.disableSubmitButton = false;
                    this.$emit('update:progress', this.disableSubmitButton);
                }
            }
        
        }
    }

    public setFields(): void {
        this.vehicleFields = [
            // Name
            {
                key: 'name',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 30,
                    label: this.$t('vehicleReviveCenter.reviveCenterFields.name') as string,
                    required: true,
                    disabled: false,
                    rules:[
                        v => this.required('Name',v)
                    ]
                },
            },
            // Store List
            {
                key: 'stores',
                type: 'v-alynk-textchip',
                required: true,
                templateOptions: {
                    label: this.$t('vehicleReviveCenter.reviveCenterFields.stores') as string,
                    multiple: true,
                    required: true,
                    items: this.stores,
                    text: 'dealershipName',
                    value: 'dealershipName',
                    disabled: false,
                    rules:[
                        v => this.required('Store',v)
                    ]
                },
            },
        ];
    }

    public backToList() {
        if (this.isDialog) {
            this.trigger = false;
            this.vehicleReviveCenter = {};
        } else {
            this.$router.push({
                name: 'admin.vehiclerevivecenter',
            });
        }
    }

}
